<template>
    <div class="xc-list">
        <div class="xc-list-box">
          <div class="xc-list-title" v-if="title">
            {{title}}
            <slot name="add"/>
          </div>
        </div>
		    <slot name="spin"></slot>
        <div class="xc-list-table">
            <div class="xc-list" :style="scroll?'overflow-x: scroll':''">
                <slot name="xc-table"></slot>
            </div>
            <slot name="no-data"></slot>
            <div class="xc-page" v-if="page">
                <Page 
                    @on-change="handleChange"
                    @on-page-size-change="handlePageSizeChange"
                    :total="total"
                    :page-size-opts="pageSizeOpts"
                    :current="currentPage"
                    :page-size="limit"
                    show-elevator 
                    show-sizer 
                    show-total>
                </Page>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ""
        },
        page: {
            type: Boolean,
            default: true
        },
        total:{
            type:Number,
            default:0
        },
        pageSizeOpts:{
            type:Array,
            default:()=>{return [15,30,50,100]}
        },
        currentPage:{
            type:Number,
            default:1
        },
        limit:{
            type:Number,
            default:15
        },
        scroll:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            isShowPage: true
        };
    },
    methods: {
        /**
         * 页码改变的事件派发
         * 
         * @param {Number} page 页码
         */
        handleChange(page){
            this.$emit('select-change',page);
        },
        /**
         * 切换每页条数时的事件派发
         * 
         * @param {Number} pageSize 每页条数
         */
        handlePageSizeChange(pageSize){
            this.$emit('select-page-size-change',pageSize);
        },
    }  
};
</script>
<style scoped lang="less">
.xc-list {
  position: relative;
  width: 100%;
  background: rgba(255, 255, 255, 1);

    .xc-list-title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(70, 76, 91, 1);
      padding-left: 24px;
      padding-top: 24px;
      padding-bottom: 9px;
      
      .add{
          float: right;
          margin-right: 24px;
          cursor: pointer;
      }
    }
  .xc-list-table {
    padding: 24px;
    padding-top: 0;
    table {
      background: rgba(255, 255, 255, 1);
      //border: 1px solid rgba(215, 221, 228, 1);
      border-left: 1px solid rgba(215, 221, 228, 1);
      //   border: 1px solid rgba(215, 221, 228, 1);
      thead {
        tr {
          th {
            background: rgba(245, 247, 249, 1);
            border-right: 1px solid rgba(215, 221, 228, 1);
            border-top: 1px solid rgba(215, 221, 228, 1);
            border-bottom: 1px solid rgba(215, 221, 228, 1);
          }
        }
      }
      tbody {
        tr {
          td {
            border-right: 1px solid rgba(215, 221, 228, 1);
            border-bottom: 1px solid rgba(215, 221, 228, 1);
            // border-top: 1px solid rgba(215, 221, 228, 1);
            // height: 48px;
            // line-height: 48px;
          }
        }
      }
    }
    .xc-page {
      margin-top: 24px;
      text-align: right;
    }
  }
}

tr:nth-child(2n) td {
  background: none;
}
</style>
